export const processBase64Format=(input)=> {
    const dataPart = input.split(":")[1];
    const mimeType = dataPart.split(";")[0];
    const base64Data = dataPart.split(",")[1];
    const mimeTypeWithoutPrefix = mimeType.split("/")[1];
    const output = mimeTypeWithoutPrefix + ";" + base64Data;
    return output;
}

// export const numberCommaFormat = (number, toFixed = true , country="en-IN") => {
//     const options = {  maximumFractionDigits: 2   }
//     const formattedNumber = Intl.NumberFormat(country,options).format(toFixed ? Number(number)?.toFixed(2) : Number(number));
//     return "₹ " + formattedNumber; 
// }

export const numberCommaFormat = (number, country = "en-IN") => {
    const options = {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    };
    const formattedNumber = Intl.NumberFormat(country, options).format(Number(number));
    return "₹ " + formattedNumber;
};

export const numberCommaFormatWithoutRupees = (number, toFixed = true , country="en-IN") => {
    const options = {  maximumFractionDigits: 2   }
    const formattedNumber = Intl.NumberFormat(country,options).format(toFixed ? Number(number)?.toFixed(2) : Number(number));
    return  formattedNumber; 
}
